const RootLayout = ({ children }) => children;

export const BrowserRootLayout = RootLayout;
export const SsrRootLayout = RootLayout;
